import { render, staticRenderFns } from "./SelectSbrand.vue?vue&type=template&id=25059c73&scoped=true&"
import script from "./SelectSbrand.vue?vue&type=script&lang=js&"
export * from "./SelectSbrand.vue?vue&type=script&lang=js&"
import style0 from "./SelectSbrand.vue?vue&type=style&index=0&id=25059c73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25059c73",
  null
  
)

export default component.exports